import AssistenteSubstituicaoInsumos from '../../components/AssistenteSubstituicaoInsumos';

export default AssistenteSubstituicaoInsumos;
